const useAnalytics = () => {
  const track = (eventName, properties = {}) => {
    if (!window.posthog) return;
    window.posthog.capture(eventName, { actor_type: 'human', ...properties });
  };

  return { track };
};

export default useAnalytics;
